import React, { useState, useEffect } from 'react'
import { Tabs } from 'antd'

import User from './User'
import Loyalty from './Loyalty'

export default function Users() {
  const [activeKey, setActiveKey] = useState('1')

  const handleTabChange = (key) => {
    setActiveKey(key);
  };

  return (
    <div className="card-container">
      <Tabs 
        type="card" 
        activeKey={activeKey} 
        onChange={handleTabChange}
        destroyInactiveTabPane={true}
      >
        <Tabs.TabPane tab='Users' key='1'>
          <User />
        </Tabs.TabPane>
        <Tabs.TabPane tab='Loyalty' key='2'>
          <Loyalty />
        </Tabs.TabPane>
      </Tabs>
    </div>
  )
}
